import { GameEvents } from '../../GameEvents';
import { CharacterAttack } from '../attacks/CharacterAttack';
import { CharacterBase } from '../CharacterBase';
import { CharacterEnemy } from '../CharacterEnemy';
import { CharacterStateMachineEnemy } from '../statemachines/CharacterStateMachine';

const CONFIG = {
  id: 'cyber_gorilla',
  spineid: 'cyber_gorilla',
  combatStyle: 'STATIC',
  speed: 0,
  health: 400,
  coins: 10,
  stagger: false,
  knockdown: false,
  attackRate: 2.5,
  attackRange: 400,
  attacks: [],
  bodyCollider: { width: 225, height: 200, offsetX: 20 },
};

const ATTACKS = {
  groundpound: {
    id: 'ground_pound',
    name: 'ground_pound',
    animation: 'ground_pound',
    damage: 40,
    knockdown: true,
  },
  shards: {
    id: 'shards',
    name: 'shards',
    animation: 'shards',
    damage: 10,
    knockdown: true,
  },
  powerslam: {
    id: 'power_slam',
    name: 'power_slam',
    animation: 'power_slam',
    damage: 10,
    knockdown: true,
  },
};

export class CharacterCyberGorilla extends CharacterEnemy {
  constructor(scene, x, y, config, collisionmap) {
    super(scene, x, y, CONFIG, collisionmap);
    this._grabbable = false;
    const viewport = scene.viewport;
    const tx = viewport.x + viewport.width / 2 + 400;
    this.x = tx;
    this.y = viewport.y + 550;
    this.isBoss = true;
    this.attackCount = 0;
    this.attackGroundPound = new CharacterAttack(scene, this, ATTACKS.groundpound);
    this.attackShards = new CharacterAttack(scene, this, ATTACKS.shards);
    this.attackPowerSlam = new CharacterAttack(scene, this, ATTACKS.powerslam);
  }

  targetInLane(target) {
    return Math.abs(target.y - this.y) < 48;
  }

  createStateMachine() {
    return new CharacterCyberGorillaStateMachine(this.scene, this);
  }

  chooseAttack() {
    if (Math.abs(this._heroTarget.x - this.x) < this.attackRange) {
      return this.attackGroundPound;
    } else {
      this.attackCount++;
      if (this.attackCount % 3 === 0) {
        return this.attackPowerSlam;
      } else {
        return this.attackShards;
      }
    }
  }

  handleAttackEvent() {
    switch (this.activeAttack.name) {
      case 'ground_pound':
        this.scene.shake();
        break;
      case 'power_slam':
        this.scene.shake();
        this.spawnPowerSlam();
        break;
      case 'shards':
        this.scene.shake();
        this.spawnShards();
        break;
      case 'pushback':
        this._heroTarget.x = this.x - 1;
        this._heroTarget.knockdown(-2500);
        break;
    }
  }

  spawnShards() {
    const viewport = this.scene.viewport;

    this.scene.events.emit(GameEvents.SPAWN_PROJECTILE, {
      sprite: 'shard_gorilla',
      type: 'mine',
      damage: 60,
      knockdown: true,
      x: viewport.centerX + Math.random() * 600 - 400,
      y: viewport.y + viewport.height * 0.5 + Math.random() * (viewport.height * 0.45),
      depth: this.y,
      velocity: { x: 0, y: 0 },
    });
  }

  spawnPowerSlam() {
    this.scene.events.emit(GameEvents.SPAWN_PROJECTILE, {
      sprite: 'projectile_gorilla_powerslam',
      damage: 60,
      knockdown: true,
      x: this.x + 150 * this.faceDirection,
      y: this.y,
      depth: this.y,
      velocity: { x: 1500 * this.faceDirection, y: 0 },
    });
  }

  // character does not move
  findPathToHero() {}
  updateMovement() {}
  knockdown() {}
  damage(...args) {
    super.damage(...args);
    this._cooldownAttack = 0;
  }
}

class CharacterCyberGorillaStateMachine extends CharacterStateMachineEnemy {
  idle(delta) {
    if (
      Math.abs(this.character.heroTarget.x - this.character.x) < this.character.attackRange &&
      this.character.heroTarget.canDamage
    ) {
      this.character.checkForRequestAttack(delta);
    }
    super.idle(delta);
  }
}
